import React from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { BookOpen, Plus } from 'lucide-react';
import Button from '../features/parentPortal/components/Button';
import CourseRow from '../features/parentPortal/components/CourseRow';
import EmptyState from '../features/parentPortal/components/EmptyState';

// Renders inside StudentDetailShell's <Outlet />. The shell owns the
// student header and tabs; this component owns only the tab-specific
// content (course list + assign CTA).
export default function StudentOverviewSection() {
  const navigate = useNavigate();
  const { student } = useOutletContext();

  const goAssign = () =>
    navigate(`/family/students/${encodeURIComponent(student.studentId)}/assign`);

  return (
    <section>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 'var(--space-3)',
          marginBottom: 'var(--space-3)',
        }}
      >
        <h2
          style={{
            margin: 0,
            fontSize: 'var(--text-section-size)',
            fontWeight: 'var(--text-section-weight)',
            letterSpacing: 'var(--text-section-tracking)',
            color: 'var(--text-primary)',
          }}
        >
          Courses
        </h2>
        <Button size="sm" onClick={goAssign}>
          <Plus size={14} strokeWidth={1.5} />
          Assign a course
        </Button>
      </div>

      {(student.courses || []).length === 0 ? (
        <EmptyState
          icon={<BookOpen size={22} strokeWidth={1.5} />}
          title="Get them started"
          description="Pick a topic and assign their first course — it'll show up here right away."
          action={
            <Button onClick={goAssign}>
              <Plus size={16} strokeWidth={1.5} />
              Assign a course
            </Button>
          }
        />
      ) : (
        <div style={{ display: 'grid', gap: 'var(--space-3)' }}>
          {student.courses.map((c) => (
            <CourseRow key={c.courseId} studentId={student.studentId} course={c} />
          ))}
        </div>
      )}
    </section>
  );
}
